import { History } from 'history';
import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

type Prompt = Parameters<History<unknown>['block']>[0];

export const useBlockHistory = (prompt: Prompt) => {
  const history = useHistory();

  const unblockRef = useRef<any>(null);

  useEffect(() => {
    unblockRef.current = history.block(prompt);
    return () => {
      unblockRef.current?.();
    };
  }, []);
};
